<template>
  <div>
    <b-modal
      class="mc-modal"
      id="modal-shortcut-create-mo"
      ref="mc-modal-change-status"
      :title="$t('maintenance.createMO') + ' (MO)'"
      size="lg"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>
          {{ $t('maintenance.modal.createMo', { total: selectedDataLength }) }}
        </p>
      </div>

      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.cancel')"
            @click="cancel()"
          />
          <McButton variant="primary" :text="$t('maintenance.createMO')" @click="handleCreateMO" />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },

  props: {
    selectedDataLength: {},
    selectedItems: {},
    selectedIds: {},
  },

  methods: {
    handleCreateMO() {
      const checkStatus = this.selectedItems.filter((item) => item.status.includes('I'))

      if (checkStatus.length > 0) {
        this.$bvModal.hide('modal-shortcut-create-mo')
        this.$mcToast.error(this.$t('maintenance.alert.failedMoCreate'))
        return
      }

      const data = {
        vehicle: this.selectedItems[0].vehicle,
        services: this.selectedItems,
      }
      this.$store.commit('maintenance/SET_SHORTCUT_MO', data)
      this.$router.push({ name: 'Maintenance Create Service Order' })
    },
  },
}
</script>
